import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Trophy, ArrowRight } from "lucide-react";
import api from "../lib/api";

const NAME = { uk: "UK", us: "US" };

export const WeeklyWinnerBanner = () => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/trivia/chart-leaderboard").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return null;
  const last = d.last_week.leader ? d.last_week : null;
  const cur = !last && d.this_week.leader ? d.this_week : null;
  const w = last || cur;
  if (!w) return null;
  const win = w.leader, lose = win === "uk" ? "us" : "uk";
  return (
    <section className="mb-14 cv-fade-up" data-testid="weekly-winner-banner">
      <div className="flex flex-col sm:flex-row sm:items-center gap-5 bg-[#FAF7F0] border border-[#D8CEB9] border-l-4 border-l-[#9E4535] rounded-sm px-5 sm:px-8 py-5">
        <span className="w-11 h-11 shrink-0 rounded-full bg-[#9E4535] text-[#FAF7F0] flex items-center justify-center"><Trophy className="w-5 h-5" /></span>
        <div className="flex-1 min-w-0">
          <p className="caption-label !text-[#9E4535] !text-[11px]">Trivia Vault · Chart Three {last ? "last week" : "this week"}</p>
          <p className="font-serif-display text-xl sm:text-2xl font-bold text-[#1A1615] mt-1 leading-snug" data-testid="weekly-winner-text">
            {last ? `The ${NAME[win]} won last week, ${w[win].accuracy}% to ${w[lose].accuracy}%.` : `The ${NAME[win]} leads this week, ${w[win].accuracy}% to ${w[lose].accuracy}%.`}
          </p>
          <p className="font-body text-sm text-[#4A4036] mt-1">Three chart number ones a day. Can the {NAME[lose]} hit back?</p>
        </div>
        <Link to={`/trivia/play?source=chart-daily&region=${lose}&mode=mc&count=3`} data-testid="weekly-winner-play"
          className="shrink-0 inline-flex items-center gap-2 bg-[#9E4535] text-[#FAF7F0] hover:bg-[#86392B] rounded-full px-5 py-2.5 font-ui text-sm font-semibold transition-colors">
          Play for the {NAME[lose]} <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </section>
  );
};
